/** 電話番号の表し方（画面に出すとき）。 */

/**
 * 電話番号の見せ方。携帯の11桁は「090-1234-5678」の形にして読み上げやすくする
 * （管理者が確認の電話をかけるときに読み違えないように）。それ以外は届いたまま出す。
 */
export function formatPhone(phone: string): string {
  const m = /^(0[5789]0)(\d{4})(\d{4})$/.exec(phone);
  return m ? `${m[1]}-${m[2]}-${m[3]}` : phone;
}
